import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Faq from '../views/Static/Faq.vue';
import Policy from '../views/Static/Policy.vue';
import Terms from '../views/Static/Terms.vue';
import ConsultLater from '../views/Static/ConsultLater.vue';
import ConsultNow from '../views/Static/ConsultNow.vue';
import MedicineDelivery from '../views/Static/MedicineDelivery.vue';
import Form from '../views/Form.vue';
import Download from '../views/Download.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/frequently-asked-questions',
    name: 'faq',
    component: Faq,
    props: (route) => ({ id: route.query.id }),
    children: [
      {
        path: ':tabId',
        children: [
          { path: ':articleId' },
        ],
      },
    ],
  },
  {
    path: '/terms-and-conditions',
    name: 'terms',
    component: Terms,
    props: (route) => ({ id: route.query.id }),
  },
  {
    path: '/privacy-policy',
    name: 'policy',
    component: Policy,
    props: (route) => ({ id: route.query.id }),
  },
  {
    path: '/signup',
    name: 'form',
    component: Form,
  },
  {
    path: '/download',
    name: 'download',
    component: Download,
  },
  {
    path: '/consult-later-infographics',
    name: 'consult-later',
    component: ConsultLater,
  },
  {
    path: '/consult-now-infographics',
    name: 'consult-now',
    component: ConsultNow,
  },
  {
    path: '/medicine-delivery',
    name: 'medicine-delivery',
    component: MedicineDelivery,
  },
  {
    path: '*',
    name: 'error-404',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
